export default __webpack_public_path__ + "static/media/EN_05.ca53e4b8.svg";